<template>
  <div>
    <!-- Video Call -->
    <div class="row">
      <div class="col-12">
        <iframe type="text/html" ref="vc-iframe" allow="microphone; camera" width="100%" v-if="settings" style="height: 50vh; border: 1px #d8d7d6 solid" :src="
            settings.vMaatuSettings.serverAdd +
            '?api_key=' +
            settings.vMaatuSettings.apiKey +
            '&room_name=' +
            requestedAhc._id
          "></iframe>
        <chat :to="requestedAhc.careCoordinator" :appointment-id="requestedAhc._id"></chat>
      </div>
    </div>
  </div>
</template>

<script>
import Chat from "src/pages/carenation/Chat.vue";
import socket from "@/services/socket";

export default {
  name: "requested-ahc",

  components: {
    Chat,
  },

  async mounted() {
    this.initSocket();
    window.initSocket = this.initSocket;

    socket.on("newChatMessage", async (message) => {
      if (message.chatMessage.username != this.user.username) {
        let appointment = await this.$store.dispatch(
          "getAppointment",
          message.appointmentId
        );
        this.$store.commit("setState", {
          stateName: "chatThread",
          stateValue: appointment.careCoordinatorMessages,
        });
      }
    });
  },

  computed: {
    requestedAhc() {
      return this.$store.state.selectedAhcAppointment;
    },
    settings() {
      return this.$store.state.settings;
    },
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
  },

  methods: {
    initSocket() {
      //Join appointment room
      socket.emit("joinRoom", {
        type: "appointment",
        id: this.requestedAhc._id,
        userId: this.user._id,
      });
    },
  },

  beforeDestroy() {
    socket.off("newChatMessage");
    window.initSocket = null;
  },
};
</script>

<style scoped>
/deep/ .sc-header {
  display: none;
}
/deep/ .sc-chat-window {
  height: 42vh !important;
}

@media (max-width: 450px) {
  /deep/.sc-message {
    width: 100%;
  }
}
<style scoped > /deep/.sc-message {
  width: 100%;
}
/deep/.modal-content .modal-header button {
  inset-inline-end: 9px;
  top: 9px;
}
</style>
